import { Section } from '../types/questionnaire';
import { RelativeSectionNames } from './constants';

export const getRelativeSections = (sections: Section[]): Section[] => {
  return sections.filter(section =>
    RelativeSectionNames.includes(section.name)
  );
};
